<template>
  <ValidationProvider
    :rules="{
      required: true,
      past: field.validation === DATE_VALIDATION.PAST,
      future: field.validation === DATE_VALIDATION.FUTURE,
    }"
    v-slot="{ errors, validated, valid }"
  >
    <b-field
      :label="field.label"
      v-if="visible"
      :type="{ 'is-danger': errors[0], 'is-success': validated && valid }"
      :message="errors"
      class="validator-field"
    >
      <b-datepicker
        :id="`prelimInput_${field.identifier}`"
        v-model="selectedValue"
        locale="hu-HU"
        icon-pack="fa"
        icon="calendar"
        trap-focus
        :mobile-native="false"
      >
      </b-datepicker>
    </b-field>
  </ValidationProvider>
</template>

<script>
import { formatDate } from "../../utils/util";
import { DATE_VALIDATION } from "@/utils/const";

export default {
  name: "PreliminaryDatePickerQuestion",
  props: {
    field: {
      type: Object,
      required: true,
    },
    visible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      selectedValue: null,
      DATE_VALIDATION,
    };
  },
  mounted() {
    const storedDate = this.$store.getters["preliminaryAssessment/answer"](
      this.field.identifier
    );

    if (storedDate) {
      this.selectedValue = new Date(storedDate);
    }
    this.$watch("selectedValue", this.valueWatcher);
  },
  methods: {
    valueWatcher() {
      this.$store.dispatch("preliminaryAssessment/addData", {
        question: this.field.identifier,
        answer: formatDate(this.selectedValue),
      });
    },
  },
};
</script>

<style scoped></style>
